import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import posthog from 'posthog-js'
import { getSettlementCheckStatus } from 'services/fund/settlement'

/**
 * «چقدر مانده؟» — asked the moment a manager taps تایید on the confirm modal.
 *
 * Read-only, but a mutation rather than a query: it answers a question about
 * one member at the moment it is asked, and a cached answer from ten minutes
 * ago is how you pay someone twice.
 */
export default function useCheckoutStatus(
    onAnswer: (status: IGetSettlementCheckStatusResponse) => void
) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IGetSettlementCheckStatusPayload) => {
            return getSettlementCheckStatus(payload)
        },
        onSuccess: (data) => {
            onAnswer(data)
        },
        onError: (error: any, variables) => {
            posthog.capture('exit_request_checkout_status_failed', {
                moneypool_id: variables?.moneyPool,
                status: error?.response?.status,
            })
            toast.error('وضعیت حساب این عضو خوانده نشد؛ دوباره تلاش کنید.')
        },
    })
    return { isCheckingStatus: isLoading, checkStatus: mutate }
}
